<template>
  <html>
    <head> </head>
    <body>
      <navbar></navbar>
      <div class="container-fluid header-banner">
        <!--img
          id="header-s"
          src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/Loyalty-hub-header-l.png"
        /-->
        <div class="profile-edit">
          <img class="img-profile-edit" :src="lineInfo.pictureUrl" />
        </div>

        <div class="row bg-white overflow-auto" style="padding-bottom: 20px;">
          <form method="post" style="padding:5px;">
          <div class="form-group">
                <label for="title" class="text-form">คำนำหน้า *</label>
               <input
                type="text"
                class="form-control"
                id="title"
                placeholder=""
                disabled
                v-model="regForm.title"
              />
              </div>
            <div class="form-group">
              <label for="firstname" class="text-form">ชื่อ *</label>
              <input
                type="text"
                class="form-control"
                id="firstname"
                placeholder=""
                required
                disabled
                v-model="regForm.firstname"
              />
            </div>
            <div class="form-group">
              <label for="lastname" class="text-form">นามสกุล *</label>
              <input
                type="text"
                class="form-control"
                id="lastname"
                placeholder=""
                requried
                disabled
                v-model="regForm.lastname"
              />
            </div>

            <!--div class="form-group">
              <label for="genders" class="text-form">เพศ *</label>
              <select
                type="text"
                class="form-control"
                id="genders"
                placeholder="เลือกเพศสภาพ"
                v-model="regForm.genders"
              >
                <option v-for="item in genders" :key="item.key" :value="item.key">
                  {{ item.value }}
                </option>
              </select>
            </div-->
            <div class="form-group">
              <label for="email" class="text-form">อีเมล *</label>
              <input
                type="email"
                class="form-control"
                id="email"
                placeholder="youremail@email.com"
                required
                v-model="regForm.email"
              />
            </div>
            <div class="form-group">
              <label for="phone" class="text-form">เบอร์โทรศัพท์ *</label>
              <input
                type="number"
                class="form-control"
                id="phone"
                placeholder=""
                v-model="regForm.phone"
                maxlength="10"
              />
            </div>
            <div class="form-group">
                <label for="birthdate" class="text-form">วันเกิด *</label>
                <!--dropdown-datepicker
                displayFormat="dmy"
                submitFormat:="yyyy-mm-dd"
                defaultDateFormat="yyyy-mm-dd"
                :defaultDate="regForm.birthdate"
                  v-model="regForm.birthdate"
                  class="fixdd"
                  style="width: 102%; border: 0;"
                  valueType="format"
                ></dropdown-datepicker-->
                <!--birth-date v-bind:birthDate="regForm.birthdate"></birth-date!-->
                <date-dropdown
                min="1900"
                max="2021"
                  v-model="regForm.birthdate"
                  class="fixdd"
                  style="width: 100%; border: 0; padding:2px;"
                  valueType="format"
                  disabled
                  :default="regForm.birthdate"
                  
                ></date-dropdown>
            </div>
          </form>
        </div>
        <div class="row bottom-200">
          <a @click="register" type="submit" class="btn btn-accept light-color font-color btn-lg btn-block mt-30"
            >ยืนยัน</a>
          <a
            @click="goto('Profile')"
            type="reset"
            class="btn btn-accept  btn-lg btn-block mt-3"
            >ยกเลิก</a
          >
        </div>
      </div>
    </body>
  </html>
</template>
<script>
import Navbar from "./navbar";
//import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
//import DropdownDatepicker from "vue-dropdown-datepicker";
//import SelectBirthdate from "./Birthdate";
import DateDropdown from 'vue-date-dropdown'
export default {
  name: "EditProfile",
  components: {
    navbar: Navbar,
    //"date-picker": DatePicker,
    //"dropdown-datepicker":DropdownDatepicker,
    //"birth-date" : SelectBirthdate
    "date-dropdown":DateDropdown
  },

  data() {
    return {
      regForm: {
        line_id: localStorage.getItem("line_id"),
        line_img: localStorage.getItem("line_img"),
        email: "",
        custId: "",
        apiKey: "",
        firstname: "",
        phone: "",
        birthdate: "",
        title:"",

        // localStorage.setItem("line_id", profile.userId);
        //       //localStorage.setItem("line_email", profile.email);
        //       localStorage.setItem("line_name", profile.displayName);
        //       localStorage.setItem("line_img", profile.pictureUrl);
      },
      birthdate:"",
      lineInfo: this.$store.state.lineInfo,
      genders: [
        { key: "M", value: "ชาย" },
        { key: "F", value: "หญิง" },
        { key: "N", value: "ไม่ระบุ" },
      ],
      title: [
        { key: "นาย/Mr.", value: "นาย" },
        { key: "นาง/Mrs.", value: "นาง" },
        { key: "นางสาว/Ms.", value: "นางสาว" },
      ],
    };
  },
  methods: {
    goto(page) {
      console.log(page);
      this.$router.push({
        name: page,
        /*query: {
          apiKey: localStorage.getItem("apiKey"),
          custId: localStorage.getItem("custId"),
        },
        */
      });
    },
    async register(e) {
      e.preventDefault();
      //console.log(this.regForm);
      //if(this.regForm.birthdate == ""){
      let birthdate = this.regForm.birthdate.split(".");
      this.regForm.birthdate = birthdate[2]+"-"+birthdate[1]+"-"+birthdate[0];
       
      await this.$store.dispatch("updateMember", this.regForm);
      //let isSuccess = this.$store.getters.isSuccess;
      //alert(this.$store.getters.isSuccess);
      if (this.$store.state.isSuccess) {
        //
        this.$toast.success("บันทึกข้อมูลสำเร็จ", {
          timeout: 2000,
        });
        this.$router.push({
          name: "Profile",
          /*query: {
            apiKey: localStorage.getItem("apiKey"),
            custId: localStorage.getItem("custId"),
          },*/
        });
      } else {
        //
        //alert("Error!, Update failed");
        this.$toast.error("บันทึกข้อมูลไม่สำเร็จ", {
          timeout: 2000,
        });
      }
      //}else{
      //  alert("โปรดระบุวันเกิด");
      //  }
    },
  },
  mounted(){
      console.log("Mounted Edit Profile");
      console.log(this.regForm);
    },
  beforeMount() {
    //if (this.$store.state.profile._id) {
    //alert(JSON.stringify(this.$store.state.profile));
    // this.regForm.phone = this.$store.state.profile.phone;
    // this.regForm.birthdate = this.$store.state.profile.birthdate.substring(0, 10);
    // this.regForm.firstname = this.$store.state.profile.firstname;
    // this.regForm.lastname = this.$store.state.profile.lastname;
    // this.regForm.genders = this.$store.state.profile.genders;
    // this.regForm.apiKey = localStorage.getItem("apiKey");
    // this.regForm.custId = localStorage.getItem("custId");
    // this.regForm.hubspot_id = this.$store.state.profile.hubspot_id;
    // this.regForm.email = this.$store.state.profile.email;
    //alert(JSON.stringify(this.regForm.phone));
    this.regForm = this.$store.state.profile;
    this.regForm.apiKey = localStorage.getItem("apiKey");
    this.regForm.custId = localStorage.getItem("custId");
    this.regForm.birthdate = this.$store.state.profile.birthdate.substring(0, 10);
    this.regForm.id = this.$store.state.profile._id;
    this.birthdate = this.regForm.birthdate;
    
    console.log(this.regForm);
    //}
  },
};
</script>
<style scoped>
@import "./Css/style.css";
.row {
  margin-right: 9px !important;
  margin-left: 17px !important;
  overflow: scroll;
  padding-top: 10px;
}
select.date-dropdown-select.day {
    padding: 2px;
}
.row.bg-white.overflow-auto {
    padding-left: 15px !important;
    padding-right: 15px;
}
.bg-white {
  background: #7bc79a;
  border-radius: 10px;
  min-height: 360px;
  position: relative;
  overflow: visible;
  top: 130px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 90%;
}


h1 {
  font-size: 20px;
  margin-top: 30px;
}
p {
  font-size: 16px;
  color: #7f8285;
  text-align: center;
}
.mt-30 {
  margin-top: 145px;
  text-align: center;
}
.mt-3 {
  margin-top: 126px;
  text-align: center;
  background: rgb(129, 129, 129);
}
.bt {
  bottom: 0;
  border-radius: 10px;
  position: relative;
  overflow: visible;
}
.bottom-200 {
  margin-bottom: 100px;
}
.fixdd select {
    color: #7F8285 !important;
    border-color: #ced4da !important;
}
.btn {
    transition: none !important;
    -webkit-appearance: none;
-moz-appearance: none;
appearance: none;
font-size: 18px;
}
</style>
